import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a4{align-items:stretch;}.ssr-plugin'
import '.dg{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.aw{border-radius:1.25rem;}.ssr-plugin'
import '.a8{background-color:var(--palette-white);}.ssr-plugin'
import '.cb{overflow-y:auto;}.ssr-plugin'
import '.ec{height:98dvh;}.ssr-plugin'
import '.ed{width:98vw;}.ssr-plugin'
import '.e8{overflow-y:hidden;}.ssr-plugin'
import '.da{height:min(50rem, 90vh);}.ssr-plugin'
import { styled } from 'inlines'
import { Authentication } from '../authentication/Authentication'
import { ModalWrapper } from './ModalWrapper'
import { AuthTab } from '../authentication/authTabs'
import useMediaQuery from '@app/util/useMediaQuery'

export type AuthModalProps = {
  isOpen: boolean
  tab: AuthTab
  onClose: (setUtm?: boolean) => void
  verificationTab?: AuthTab | null
}

export const AuthModal = ({
  isOpen,
  tab,
  onClose,
  verificationTab,
}: AuthModalProps) => {
  const isMobile = useMediaQuery()

  if (!isOpen) {
    return null
  }

  if (isMobile) {
    return (
      <ModalWrapper>
        <div className="d e a4 dg aw a8 cb ec ed"
        >
          <Authentication
            tab={tab}
            onClose={onClose}
            verificationTab={verificationTab}
          />
        </div>
      </ModalWrapper>
    )
  }

  return (
    <ModalWrapper>
      <div className="d e a4 dg aw a8 e8 da"
        style={{
          maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',}}
      >
        <Authentication
          tab={tab}
          onClose={onClose}
          verificationTab={verificationTab}
        />
      </div>
    </ModalWrapper>
  )
}
